import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardActions, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { PageTitleComponent } from '@howdeniberia/core-front';

@Component({
  selector: 'howden-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [MatCard, MatCardHeader, MatCardTitle, MatDivider, MatCardActions, MatButton, MatIcon, PageTitleComponent]
})
export class HomeComponent {
  private router = inject(Router);

  onSane() { this.router.navigate(['sane-projects/edit']); }
  onHealth() { this.router.navigate(['health-projects/search']); }
  onRcSham() { this.router.navigate(['rc-sham-projects/search']); }

  onFileLibrary(): void {
    const url = 'https://intranet.app.howdeniberia.com/Biblioteca#Responsabilidad-civil';

    const a = document.createElement('a');
    a.href = url;
    a.target = '_self';
    a.rel = 'noreferrer';
    a.style.display = 'none';

    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}
